const countryIsoMap: { [key: string]: string } = {
    Argentina: 'AR',
    Australia: 'AU',
    Barbados: 'BB',
    Belgia: 'BE',
    Belgium: 'BE',
    Bermuda: 'BM',
    Bolivia: 'BO',
    Botswana: 'BW',
    Brasil: 'BR',
    Brazil: 'BR',
    Bulgaria: 'BG',
    CHILE: 'CL',
    Chile: 'CL',
    Colombia: 'CO',
    Cuba: 'CU',
    Danmark: 'DK',
    Denmark: 'DK',
    'Den dominikanske republikk': 'DO',
    'Dominican Republic': 'DO',
    Ecuador: 'EC',
    Egypt: 'EG',
    EU: 'EU',
    Estland: 'EE',
    Estonia: 'EE',
    Etiopia: 'ET',
    Ethiopia: 'ET',
    Filippinene: 'PH',
    Philippines: 'PH',
    Finland: 'FI',
    Frankrike: 'FR',
    France: 'FR',
    Georgia: 'GE',
    Grønland: 'GL',
    Greenland: 'GL',
    Guatemala: 'GT',
    Hellas: 'GR',
    Greece: 'GR',
    Hongkong: 'HK',
    'Hong Kong': 'HK',
    India: 'IN',
    Indonesia: 'ID',
    Iran: 'IR',
    Irland: 'IE',
    Ireland: 'IE',
    Island: 'IS',
    Iceland: 'IS',
    Israel: 'IL',
    Italia: 'IT',
    Italy: 'IT',
    Jamaica: 'JM',
    Japan: 'JP',
    Kasakhstan: 'KZ',
    Kazakhstan: 'KZ',
    Kenya: 'KE',
    Kina: 'CN',
    China: 'CN',
    Kroatia: 'HR',
    Croatia: 'HR',
    Kypros: 'CY',
    Cyprus: 'CY',
    Latvia: 'LV',
    Libanon: 'LB',
    Lebanon: 'LB',
    Litauen: 'LT',
    Lithuania: 'LT',
    Luxembourg: 'LU',
    Madagaskar: 'MG',
    Madagascar: 'MG',
    Makedonia: 'MK',
    Macedonia: 'MK',
    Malawi: 'MW',
    Malaysia: 'MY',
    Maldivene: 'MV',
    Maldives: 'MV',
    Marokko: 'MA',
    Morocco: 'MA',
    Mauritius: 'MU',
    Mexico: 'MX',
    Moldova: 'MD',
    Namibia: 'NA',
    Nederland: 'NL',
    Netherlands: 'NL',
    'New Zealand': 'NZ',
    Nicaragua: 'NI',
    'Nord-Korea': 'KP',
    'North Korea': 'KP',
    Norge: 'NO',
    Norway: 'NO',
    Pakistan: 'PK',
    'Papua Ny-Guinea': 'PG',
    'Papua New Guinea': 'PG',
    Paraguay: 'PY',
    Peru: 'PE',
    Polen: 'PL',
    Poland: 'PL',
    Portugal: 'PT',
    'Puerto Rico': 'PR',
    Romania: 'RO',
    Serbia: 'RS',
    Singapore: 'SG',
    Slovakia: 'SK',
    Slovenia: 'SI',
    Spania: 'ES',
    Spain: 'ES',
    'Sri Lanka': 'LK',
    Storbritannia: 'GB',
    'United Kingdom': 'GB',
    UK: 'GB',
    Svalbard: 'SJ',
    Sveits: 'CH',
    Switzerland: 'CH',
    Sverige: 'SE',
    Sweden: 'SE',
    'Sør-Afrika': 'ZA',
    'South Africa': 'ZA',
    'Sør-Korea': 'KR',
    'South Korea': 'KR',
    Taiwan: 'TW',
    Thailand: 'TH',
    Togo: 'TG',
    'Trinidad og Tobago': 'TT',
    'Trinidad and Tobago': 'TT',
    Tsjekkia: 'CZ',
    Czechia: 'CZ',
    'Czech Republic': 'CZ',
    Tunisia: 'TN',
    Tyrkia: 'TR',
    Turkey: 'TR',
    Tyskland: 'DE',
    Germany: 'DE',
    USA: 'US',
    'United States': 'US',
    Ukraina: 'UA',
    Ukraine: 'UA',
    Ungarn: 'HU',
    Hungary: 'HU',
    Uruguay: 'UY',
    Venezuela: 'VE',
    Vietnam: 'VN',
    canada: 'CA',
    Canada: 'CA',
    Østerrike: 'AT',
    Austria: 'AT'
};

export default countryIsoMap;
